"use client";
import Image from "@/components/Image";

const Advantage = () => {
  return (
    <section className="w-full px-[80px] [@media(min-width:769px)_and_(max-width:1080px)]:px-[40px] [@media(max-width:768px)]:px-[20px] gap-[10px] bg-white">
      <div className="w-full max-w-[1360px] pt-[90px] pb-[140px] [@media(max-width:414px)]:pb-[90px] mx-auto flex flex-col gap-[70px]">
        <div className="w-full flex flex-col justify-content items-center gap-[20px]">
          <div className="font-[PingFang-SC] font-semibold text-[46px] [@media(min-width:415px)_and_(max-width:660px)]:text-[40px] [@media(max-width:414px)]:text-[clamp(2rem,9vw,2.5rem)] leading-[52px] tracking-normal text-center text-[#333333]">
            为什么选择蜜蜂家校
          </div>
          <div className="font-[PingFang-SC] font-normal text-[18px] [@media(max-width:660px)]:text-[14px] leading-[28px] tracking-[2px] text-center text-[#666666]">
            蜜蜂AI功能全面，扫描全能王出品，助力老师有效开展“人工智能+教与学”
          </div>
        </div>
        <div className="w-full flex [@media(max-width:768px)]:flex-col flex-row items-start gap-[clamp(10px,3vw,50px)]">
          <div className="w-full flex-1 flex flex-col items-center">
            <Image
              src="/Group1_06.png"
              alt="01"
              width={98}
              height={80}
              className="mx-auto"
            />
            <div className="w-full min-h-[522px] rounded-[20px] py-[30px] px-[40px] [@media(max-width:414px)]:px-[20px] flex flex-col gap-[34px] hover:bg-[#F8FAFD] [@media(max-width:768px)]:bg-[#F8FAFD] cursor-pointer">
              <div className="w-full rounded-[12px] overflow-hidden shrink-0">
                <Image
                  src="/advantage_picture1_06.png"
                  alt="领先的算法技术"
                  width={340}
                  height={146}
                  className="mx-auto"
                />
              </div>
              <div className="w-full flex flex-col gap-[20px]">
                <div className="font-[PingFang-SC] font-semibold text-[24px] leading-[24px] tracking-[0px] text-center text-[#333333]">
                  领先的算法技术
                </div>
                <div className="font-[PingFang-SC] font-normal text-[18px] leading-[34px] tracking-[0px] text-[#666666]">
                  智能文字识别/图像处理/知识图谱生成等技术，稳居国内AI赋能教与学头部梯队；
                  精准识别，快速批改，解决字迹潦草、密集题型等“老大难”问题，深入教学使用场景，提升老师使用体验。
                </div>
              </div>
            </div>
          </div>
          <div className="w-full flex-1 flex flex-col items-center">
            <Image
              src="/Group2_06.png"
              alt="02"
              width={98}
              height={80}
              className="mx-auto"
            />
            <div className="w-full min-h-[522px] rounded-[20px] py-[30px] px-[40px] [@media(max-width:414px)]:px-[20px] flex flex-col gap-[34px] hover:bg-[#F8FAFD] [@media(max-width:768px)]:bg-[#F8FAFD] cursor-pointer">
              <div className="w-full rounded-[12px] overflow-hidden shrink-0">
                <Image
                  src="/advantage_picture2_06.png"
                  alt="丰富的产品矩阵"
                  width={340}
                  height={146}
                  className="mx-auto"
                />
              </div>
              <div className="w-full flex h-full flex-col gap-[20px]">
                <div className="font-[PingFang-SC] font-semibold text-[24px] [@media(max-width:414px)]:text-[20px] leading-[24px] tracking-[0px] text-center text-[#333333]">
                  丰富的产品矩阵
                </div>
                <div className="font-[PingFang-SC] font-normal text-[18px] [@media(max-width:414px)]:text-[14px] leading-[34px] tracking-[0px] text-[#666666]">
                  微信小程序/电脑操作网页版，校园版加配软硬一体蜜蜂智阅一体机，丰富的产品形态和用户使用终端，便利老师、学生、家长使用，校园部署更省心；
                  <br />
                  蜜蜂家校小程序支持微信、QQ、钉钉、企微等分享，免下载，免安装。搜索注册即可使用。
                </div>
              </div>
            </div>
          </div>
          <div className="w-full flex-1 flex flex-col items-center">
            <Image
              src="/Group3_06.png"
              alt="03"
              width={98}
              height={80}
              className="mx-auto"
            />
            <div className="w-full min-h-[522px] rounded-[20px] py-[30px] px-[40px] [@media(max-width:414px)]:px-[20px] flex flex-col gap-[34px] hover:bg-[#F8FAFD] [@media(max-width:768px)]:bg-[#F8FAFD] cursor-pointer">
              <div className="w-full rounded-[12px] overflow-hidden shrink-0">
                <Image
                  src="/advantage_picture3_06.png"
                  alt="专业的服务团队"
                  width={340}
                  height={146}
                  className="mx-auto"
                />
              </div>
              <div className="w-full flex flex-col gap-[20px]">
                <div className="font-[PingFang-SC] font-semibold text-[24px] leading-[24px] tracking-[0px] text-center text-[#333333]">
                  专业的服务团队
                </div>
                <div className="font-[PingFang-SC] font-normal text-[18px] leading-[34px] tracking-[0px] text-[#666666]">
                  个人版专属在线客服服务，校园版配备专属入校驻场运维服务：迅速响应，节省你的时间成本；
                  <br />
                  技术专家团队，高效协作处理机制，为产品运转保驾护航。
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Advantage;
